<template>
    <section :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-slate-50'" class="tw-rounded-2xl  tw-shadow-2xl tw-overflow-hidden">
        <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-slate-700' : 'tw-bg-[#e9eef6] tw-border-[#d1d5db]'" class="tw-border-b tw-px-6 tw-py-4 tw-flex tw-items-center tw-justify-between tw-gap-4 tw-flex-wrap">
            <div class="tw-flex tw-items-center tw-gap-3">
                <div :class="theme === 'dark' ? 'tw-bg-indigo-500/10 tw-text-indigo-400' : 'tw-bg-indigo-50 tw-text-indigo-600'" class="tw-p-2.5 tw-rounded-lg">
                    <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/></svg>
                </div>
                <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Histórico da Estação</h3>
            </div>
            <div class="tw-flex tw-items-center tw-gap-3 tw-w-full sm:tw-w-auto">
                <input 
                    type="date" 
                    v-model="inputDate"
                    :class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-white' : 'tw-bg-white tw-text-slate-900'"
                    class="tw-flex-1 sm:tw-flex-none tw-min-w-0 tw-px-3 tw-py-2 tw-rounded-lg tw-text-sm"
                >
                <button 
                    @click="alterarData"
                    :class="theme === 'dark' ? 'tw-bg-emerald-600 hover:tw-bg-emerald-700 focus:tw-ring-emerald-500/20' : 'tw-bg-emerald-600 hover:tw-bg-emerald-700 focus:tw-ring-emerald-100'"
                    class="tw-shrink-0 tw-px-4 tw-py-2 tw-text-white tw-text-sm tw-font-semibold tw-rounded-lg tw-shadow-sm focus:tw-ring-4"
                >
                    Alterar data
                </button>
            </div>
        </div>
        <div class="tw-p-3 md:tw-p-6">
            <div class="tw-relative tw-w-full tw-h-72 md:tw-h-80">
                <canvas id="temperatureChart"></canvas>
            </div>
        </div>
    </section>
</template>
<script>
import { ref, computed, watch } from 'vue';
import Chart from 'chart.js/auto';
import { useToast } from 'vue-toastification';
import { useStore } from "vuex";
import { useRoute } from 'vue-router';

export default {
    name: 'DashboardGraficoEstacao',
    props: {
        unidade: {
            type: Object,
            required: true
        }
    },

	setup(props, { emit }) {
		const store = useStore();
		const route = useRoute();
        const selectedDate = ref(new Date().toISOString().slice(0, 10));
		const inputDate = ref(selectedDate.value);
        const estacaoData = ref([]);
        const toast = useToast();
        const theme = computed(() => store.state.ui.theme);

        watch(theme, () => {
            if (estacaoData.value.length) renderChart();
        });

        const alterarData = async () => {
			const previousSelectedDate = selectedDate.value;
			try {
				selectedDate.value = inputDate.value;
				await fetchEstacaoData();
			} catch (error) {
				selectedDate.value = previousSelectedDate;
			}
		};

        const fetchEstacaoData = async () => {
			emit('update-loading', true);
			const unidadeId = route.params.unidade;

			const body = {
				unidadeId: unidadeId,
				dataInicio: selectedDate.value,
				dataFim: selectedDate.value,
				per_page: 'all'
			};

			try {
				const response = await store.dispatch("estacao/fetchEstacaoDataRelatorio", body);
				if (!response.isAxiosError) {
					estacaoData.value = response.data;
					renderChart();
				}
			} catch (error) {
				if (error.isAxiosError) {
					window.chartInstance.destroy();
					toast.error('Não foi encontrado dados para a data selecionada', { timeout: 4000 });
				}
				throw error;
			} finally {
				emit('update-loading', false);
			}
		};

        const renderChart = () => {
			const canvas = document.getElementById('temperatureChart');
			if (!canvas) {
				console.warn('Canvas graficoEstacao não encontrado');
				return;
			}
			const ctx = canvas.getContext('2d');
			if (window.chartInstance) {
				window.chartInstance.destroy();
			}
			const labels = [];
			const temperatureData = [];
			const humidityData = [];
			const dadosOrdenados = [...estacaoData.value].sort((a, b) => new Date(a.data) - new Date(b.data));
			const totalData = dadosOrdenados.length;
			const interval = Math.max(1, Math.ceil(totalData / 30));

			for (let i = 0; i < totalData; i++) {
				if (i % interval === 0 || i === totalData - 1) {
					const item = dadosOrdenados[i];
					const itemDate = new Date(item.data);
					const hourLabel = `${itemDate.getHours() < 10 ? '0' + itemDate.getHours() : itemDate.getHours()}:${itemDate.getMinutes() < 10 ? '0' + itemDate.getMinutes() : itemDate.getMinutes()}`;

						labels.push(hourLabel);
						temperatureData.push(item.temperatura || 0);
						humidityData.push(item.umidade || 0);
					}
				}

			const isDark = theme.value === 'dark';
			const isMobile = window.innerWidth < 640;
			const textColor = isDark ? '#cbd5e1' : '#475569';
			const gridColor = isDark ? 'rgba(148,163,184,0.15)' : 'rgba(100,116,139,0.12)';
			const tempMin = temperatureData.length ? Math.min(...temperatureData) - 3 : 0;
			const tempMax = temperatureData.length ? Math.max(...temperatureData) + 3 : 10;

			window.chartInstance = new Chart(ctx, {
				type: 'line',
				data: {
					labels: labels,
					datasets: [
						{
							label: 'Temperatura (°C)',
							data: temperatureData,
							borderColor: '#23d726',
							backgroundColor: 'rgba(35,215,38,0.08)',
							borderWidth: 2,
							pointRadius: isMobile ? 0 : 2,
							pointHoverRadius: 4,
							tension: 0.35,
							fill: true,
							yAxisID: 'y1',
						},
						{
							label: 'Umidade (%)',
							data: humidityData,
							borderColor: '#1E90FF',
							backgroundColor: 'rgba(30,144,255,0.06)',
							borderWidth: 2,
							pointRadius: isMobile ? 0 : 2,
							pointHoverRadius: 4,
							tension: 0.35,
							fill: false,
							yAxisID: 'y2',
						},
					]
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					interaction: { mode: 'index', intersect: false },
					plugins: {
						legend: {
							labels: { color: textColor, usePointStyle: true, boxWidth: 8, padding: 16 }
						},
						tooltip: { mode: 'index', intersect: false }
					},
					scales: {
						x: {
							title: { display: !isMobile, text: 'Horário', color: textColor },
							grid: { color: gridColor, display: !isMobile },
							ticks: {
								color: textColor,
								autoSkip: true,
								maxTicksLimit: isMobile ? 6 : 12,
								maxRotation: isMobile ? 0 : 45,
								minRotation: 0,
							}
						},
						y1: {
							position: 'left',
							title: { display: !isMobile, text: 'Temperatura (°C)', color: textColor },
							grid: { color: gridColor },
							min: tempMin,
							max: tempMax,
							ticks: { color: textColor, stepSize: 3 }
						},
						y2: {
							position: 'right',
							title: { display: !isMobile, text: 'Umidade (%)', color: textColor },
							grid: { drawOnChartArea: false },
							min: 0,
							max: 100,
							ticks: { color: textColor, stepSize: 20 }
						},
					}
				}
			});
			window.chartInstance.resize();
		};

        return {
            inputDate,
            alterarData,
            fetchEstacaoData,
            theme
        };
    }
}
</script>